import { render, staticRenderFns } from "./bidlist.vue?vue&type=template&id=027c8d08&"
import script from "./bidlist.vue?vue&type=script&lang=js&"
export * from "./bidlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports